/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     权限数据状态管理
  +--------------------------------------------------------------------------------------
*/

import dynamicViewsMap from '@/router/dynamicViewsMap'
import staticRoutes from '@/router/staticRoutes'
import TheLayout from '@/views/layout/TheLayout'
import TheLayoutView from '@/views/layout/TheLayoutView'
import { isExternalLink } from '@/utils/common'

/**
 * frames2Routes: Frames数组转动态路由配置
 */
function frames2Routes(frames) {
  const dynamicRoutes = []
  for (const frameKey in frames) {
    const frame = frames[frameKey]
    const frameRoutes = {
      component: TheLayout,
      meta: {
        frame: frame.name,
        abbr: frame.abbr,
        title: frame.title,
        icon: frame.icon,
        show: frame.is_display,
        blank: frame.is_blank,
        layout: frame.layout
      }
    }

    // 模块已开通，有二级
    if (frame.children && frame.children.length > 0) {
      frameRoutes.path = frame.url
      frameRoutes.name = frame.name
      const frameRoutesChildren = []
      for (const sectionKey in frame.children) {
        const section = frame.children[sectionKey]
        const sectionRoutes = {
          path: section.url,
          name: section.name,
          meta: {
            frame: frame.name,
            title: section.title,
            show: section.is_display,
            blank: section.is_blank,
            layout: section.layout
          }
        }
        if (!section.children) {
          if (dynamicViewsMap.hasOwnProperty(section.name) || isExternalLink(section.url)) {
            sectionRoutes.component = dynamicViewsMap[section.name]
            frameRoutesChildren.push(sectionRoutes)
          }
        } else {
          sectionRoutes.component = TheLayoutView
          sectionRoutes.children = []
          for (const menuKey in section.children) {
            const menu = section.children[menuKey]
            if (dynamicViewsMap.hasOwnProperty(menu.name) || isExternalLink(menu.url)) {
              const menuRoutes = {
                path: menu.url,
                name: menu.name,
                component: dynamicViewsMap[menu.name],
                meta: {
                  frame: frame.name,
                  title: menu.title,
                  show: menu.is_display,
                  blank: menu.is_blank,
                  layout: menu.layout
                }
              }
              sectionRoutes.children.push(menuRoutes)
            }
          }
          // 二级缺省重定向
          if (sectionRoutes.children.length > 0) {
            sectionRoutes.redirect = sectionRoutes.children[0].path
          } else {
            sectionRoutes.redirect = '/'
          }
          frameRoutesChildren.push(sectionRoutes)
        }
      }
      frameRoutes.children = frameRoutesChildren
      frameRoutes.redirect = frameRoutesChildren[0] ? frameRoutesChildren[0].path : '/'
    } else {
    // 模块未开通，无二级，进入介绍页
      frameRoutes.path = '/'
      frameRoutes.children = [{
        path: frame.url,
        name: frame.name,
        component: dynamicViewsMap[frame.name],
        meta: {
          frame: frame.name,
          title: frame.title,
          show: frame.is_display,
          blank: frame.is_blank,
          layout: frame.layout,
        }
      }]
    }

    dynamicRoutes.push(frameRoutes)
  }
  return dynamicRoutes
}

const permissionStore = {
  state: {
    routes: staticRoutes,
    dynamicRoutes: [],

    currentFrame: '',
    currentMenus: {}
  },

  mutations: {
    SET_ROUTERS: (state, dynamicRoutes) => {
      state.dynamicRoutes = dynamicRoutes
      state.routes = staticRoutes.concat(dynamicRoutes)
      // console.log('动态路由已挂载', state.dynamicRoutes, state.routes)
    },

    SET_CURRENT_FRAME: (state, frame) => {
      state.currentFrame = {}
      state.currentMenus = {}
      state.routes.forEach(v => {
        if ((v.name && v.name === frame) || (v.meta && v.meta.frame === frame)) {
          state.currentFrame = Object.assign({}, v.meta)
          state.currentMenus = Object.assign({}, v)
        }
        if(frame == 'upgrade' && v.name == 'Home') {
          state.currentFrame = Object.assign({}, v.children[1].meta)
          state.currentMenus = Object.assign({}, v.children[1])
        }
        if(frame == 'report' && v.name == 'Home') {
          state.currentFrame = Object.assign({}, v.children[2].meta)
          state.currentMenus = Object.assign({}, v.children[2])
        }
        if(frame == 'todo' && v.name == 'Home') {
          state.currentFrame = Object.assign({}, v.children[3].meta)
          state.currentMenus = Object.assign({}, v.children[3])
        }
      })
    },

  },

  actions: {
    generateRoutes({ commit }, frames) {
      return new Promise(resolve => {
        commit('SET_ROUTERS', frames2Routes(frames))
        resolve()
      })
    },

    changeFrame({ commit }, frame) {
      return new Promise(resolve => {
        commit('SET_CURRENT_FRAME', frame)
        resolve()
      })
    }
  }
}

export default permissionStore
